import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ISearchCtx, IApiResponse, IProject } from '@mvm/api-interfaces';
import { API } from './apiutil';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ProjectsService {
    http;
    constructor(http) {
        this.http = http;
    }
    create(payload) {
        return this.http.post(`${environment.base}/project`, payload);
    }
    search(ctx) {
        return this.http.get(`${environment.base}/project`, {
            params: API.makeParams(ctx),
        });
    }
    static ɵfac = function ProjectsService_Factory(t) { return new (t || ProjectsService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProjectsService, factory: ProjectsService.ɵfac });
}
